const fonts = {
  heading: `'Alegreya Variable', sans-serif`,
  body: `'Alegreya Variable', sans-serif`,
  p: `'Roboto', sans-serif`
};

export default fonts;
